document.addEventListener('DOMContentLoaded', initFaqTabsFilters);
document.addEventListener('shopify:section:load', initFaqTabsFilters);

function initFaqTabsFilters(event) {
  const scope = (event && event.target) ? event.target : document;
  const lists = scope.querySelectorAll
    ? scope.querySelectorAll('[data-faqtabs-list]')
    : document.querySelectorAll('[data-faqtabs-list]');

  lists.forEach((list) => {
    if (list.dataset.faqtabsInitialized === 'true') return;
    list.dataset.faqtabsInitialized = 'true';
    setupFaqTabsList(list);
  });
}

function setupFaqTabsList(list) {
  const container = list.closest('.grid__item') || list.parentElement;
  if (!container) return;

  const searchInput = document.querySelector('[data-faqtabs-search]');
  const tabButtons = container.querySelectorAll('[data-faqtabs-tab]');
  const noResults = container.querySelector('[data-faqtabs-no-results]');
  const items = list.querySelectorAll('[data-faqtabs-item]');

  let activeTab = 'all';

  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function applyFilters() {
    const query = normalize(searchInput ? searchInput.value : '');
    let visibleCount = 0;

    items.forEach((item) => {
      const itemCategory = item.dataset.faqtabsCategory || '';
      const belongsToActiveTab = activeTab === 'all' || itemCategory === activeTab;

      const searchText = normalize(item.dataset.faqtabsSearchText || '');
      const matchesQuery = query === '' || searchText.indexOf(query) !== -1;

      const shouldShow = belongsToActiveTab && matchesQuery;

      if (shouldShow) {
        item.hidden = false;
        visibleCount += 1;
      } else {
        item.hidden = true;
        const details = item.querySelector('details');
        if (details) details.removeAttribute('open');
      }
    });

    if (noResults) {
      noResults.hidden = visibleCount !== 0;
    }
  }

  if (tabButtons.length) {
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        tabButtons.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        activeTab = btn.dataset.faqtabsTab;
        applyFilters();
      });
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  applyFilters();
}
